import type { HealthResponse } from '@alterium/shared';
import { api } from './client';

export interface PingJobRef {
  jobId: string;
  queue: string;
  status: string;
}

export interface PingJobState {
  jobId: string;
  status: string;
  progress: number | object;
  attempts: number;
  result: {
    pong: true;
    note: string | null;
    requestedAt: string;
    processedAt: string;
    workerPid: number;
  } | null;
  failedReason: string | null;
}

export const systemApi = {
  health: () => api.get<HealthResponse>('/health'),
  enqueuePing: (note?: string) => api.post<PingJobRef>('/dev/jobs/ping', note ? { note } : {}),
  pingState: (jobId: string) => api.get<PingJobState>(`/dev/jobs/ping/${jobId}`),
};
